import { BaseApi } from "../BaseApi";

let API: BaseApi | null = null;

function getApiInstance(): BaseApi {
  if (!API) {
    API = new BaseApi();
  }
  return API;
}

export function getPresenceList(date?: string) {
  try {
    return getApiInstance().get("presence/list", date ? { date } : undefined);
  } catch (error) {
    console.error("Error fetching presence list:", error);
  }
}

export function markPresence(params: {
  user: string;
  date: string;
  status: string;
  checkInTime?: string;
  checkOutTime?: string;
  comment?: string;
}) {
  try {
    return getApiInstance().post("presence", params);
  } catch (error) {
    console.error("Error marking presence:", error);
  }
}

export function deletePresence(id: string) {
  try {
    return getApiInstance().axiosInstance.delete(`presence/${id}`, { timeout: 10000 });
  } catch (error) {
    console.error("Error deleting presence:", error);
  }
}
